<template>
  <table class="copyable-table">
    <thead>
      <tr>
        <th>日期</th>
        <th>标的名称</th>
        <th>标的代码</th>
        <th>用户</th>
        <th>类型</th>
        <th>7095报价</th>
        <th>香草报价</th>
        <th>雪球报价</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(row, index) in uniqueTableData" :key="index">
        <td>{{ row.date }}</td>
         <td>
          <a :href="`https://www.iwencai.com/unifiedwap/result?querytype=stock&w=${row.stock_name}`" target="_blank" class="stock-link">
            {{ row.stock_name }}
          </a>
        </td>
        <td>
          <a :href="`/stock-detail?stock_code=${row.stock_code}`" target="_blank" class="stock-link">
            {{ row.stock_code }}
          </a>
        </td>
        <td>
            {{ row.user_name }}
        </td>
        <td>
            {{ row.types }}

        </td>

         <td>
          <a :href="`/risky-search-form?searchQuery=${row.stock_name}+${row.stock_code}`" target="_blank" class="stock-link">
           7095报价
          </a>
        </td>


         <td>
          <a :href="`/stock-search-form?searchQuery=${row.stock_name}+${row.stock_code}`" target="_blank" class="stock-link">
             香草报价
          </a>
        </td>

         <td>
          <a :href="`/stock-search-form-xq?searchQuery=${row.stock_name}+${row.stock_code}`" target="_blank" class="stock-link">
              雪球报价
           </a>
        </td>
         <td>
          <a :href="`https://finance.baidu.com/stock/ab-${row.stock_code.slice(0, 6)}`" target="_blank" class="stock-link">
              百度股评
           </a>
        </td>

      </tr>
    </tbody>
  </table>
</template>


<script>
import { copyTableToImage } from '@/utils/utils';

export default {
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    now_str: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {
      currentDate: ''
    };
  },
  computed: {
      formattedTableData() {
          if (!this.tableData || !Array.isArray(this.tableData) || this.tableData.length === 0) {
            return [];
          }
          console.log(this.tableData);
          return this.tableData.map(record => {
            // 如果 record.data 是对象，直接使用
            if (typeof record.data === 'object' && record.data !== null) {
              return {
                date: record.data.date || '',
                stock_code: record.data.stock_code || '',
                stock_name: record.data.stock_name || '',
                user_name: record.data.user_name || '',
                types: record.data.types || ''
              };
            }

            // 如果 record.data 是 JSON 字符串，解析它
            if (typeof record.data === 'string') {
              try {
                const parsedData = JSON.parse(record.data);
                return {
                  date: record.data.date || '',
                  stock_code: parsedData.stock_code || '',
                  stock_name: parsedData.stock_name || '',
                  user_name: record.data.user_name || '',
                  types: record.data.types || ''
                };
              } catch (e) {
                console.error('解析数据失败:', e);
              }
            }

            // 默认情况
            return {
              date: record.date || '',
              stock_code: '',
              stock_name: ''
            };
          });
    },
     uniqueTableData() {
        if (!this.formattedTableData || !Array.isArray(this.formattedTableData)) {
          return [];
        }

        const seen = new Set();
        return this.formattedTableData.filter(row => {
          if (seen.has(row.stock_name)) {
            return false;
          }
          seen.add(row.stock_name);
          return true;
        });
      }
  },
  methods: {
    roundPercent(value) {
      if (typeof value === 'string' && value.includes('%')) {
        const parsedValue = parseFloat(value.replace('%', '')) || 0;
        if (parsedValue < 1) {
          return (parsedValue * 100).toFixed(3) + '%';
        } else {
          return parsedValue.toFixed(2) + '%';
        }
      }
      const numericValue = parseFloat(value) || 0;
      return numericValue !== null && numericValue !== undefined ? (numericValue * 100).toFixed(2) + '%' : '0.0%';
    },
    isMinValue(row, key) {
      const values = Object.values(row).slice(6).map(v => {
        let parsedValue = 0;
        if (typeof v === 'string' && v.includes('%')) {
          parsedValue = parseFloat(v.replace('%', '')) || 0;
        } else {
          parsedValue = parseFloat(v) || 0;
        }
        if (parsedValue > 0 && parsedValue < 1) {
          parsedValue *= 100;
        }
        return parsedValue;
      }).filter(v => !isNaN(v) && v !== 0);

      if (values.length === 0) {
        return false;
      }

      const minValue = Math.min(...values);
      let value = 0;
      if (typeof row[key] === 'string' && row[key].includes('%')) {
        value = parseFloat(row[key].replace('%', '')) || 0;
      } else {
        value = parseFloat(row[key]) || 0;
      }
      if (value > 0 && value < 1) {
        value *= 100;
      }
      return value === minValue;
    },
    copyTableToImage() {
      const table = document.querySelector('.copyable-table');
      const firstRow = table.rows[1];
      const thirdCell = firstRow.cells[2];
      const cellContent = thirdCell.textContent;
      const fileName = '个股【'+cellContent+'】期权查询情况_' + this.currentDate + '.png';
      copyTableToImage(table, fileName);
    },
    copyTableYhToImage() {
      // 创建一个新的表格用于复制到图像
      const tempTable = document.createElement('table');
      tempTable.className = 'copyable-table';

      // 添加表头
      const thead = document.createElement('thead');
      const headerRow = document.createElement('tr');
      const headers = ['日期', '询价标的', '标的名称'];
      headers.forEach(header => {
        const th = document.createElement('th');
        th.textContent = header;
        headerRow.appendChild(th);
      });
      thead.appendChild(headerRow);
      tempTable.appendChild(thead);

      // 添加表体
      const tbody = document.createElement('tbody');
      this.tableData.forEach(row => {
        const tr = document.createElement('tr');
        const cells = [row.date, row.stock_code, row.stock_name];
        cells.forEach(cell => {
          const td = document.createElement('td');
          td.textContent = cell;
          tr.appendChild(td);
        });
        tbody.appendChild(tr);
      });
      tempTable.appendChild(tbody);

      const firstRow = tempTable.rows[1];
      const thirdCell = firstRow.cells[2];
      const cellContent = thirdCell.textContent;
      console.log(tempTable);
      const fileName = '个股【'+cellContent+'】期权查询情况_' + this.currentDate + '.png';
      copyTableToImage(tempTable, fileName);
    },
    yh_price() {
          const table = document.querySelector('.copyable-table');
          const firstRow = table.rows[1];
          const thirdCell = firstRow.cells[1];
          const fourCell = firstRow.cells[2];

          const stock_code = thirdCell.textContent;
          const stock_name = fourCell.textContent;

          let text = " 标的：" + stock_name + " " + stock_code + "\n";
          text += " 期权结构：100%\n";
          text += " 名义本金：100W\n";
          text += " 期权费率：100%\n";
          text += " 时间期限：1M";

          // 使用 Clipboard API 将内容复制到剪贴板
          navigator.clipboard.writeText(text)
            .then(() => {
              console.log('内容已成功复制到剪贴板');
              alert('内容已成功复制到剪贴板');
            })
            .catch(err => {
              console.error('无法复制内容到剪贴板', err);
              alert('无法复制内容到剪贴板');
            });
        }

  },mounted() {
    // 初始化时调用一次

  }
};
</script>

<style scoped>


/* 美化 a 标签 */
.stock-link {
  color: #000; /* 链接颜色 */
  text-decoration: none; /* 去掉下划线 */
  transition: color 0.3s; /* 过渡效果 */
}

.stock-link:hover {
  color: #0056b3; /* 悬停时的颜色 */
  text-decoration: underline; /* 悬停时显示下划线 */
}
</style>